import Elemento from "./Elemento.js";

export default class Campo extends Elemento {
  constructor() {
    super();
    this.acabados = new Array();
    this.acabadoSel;
    this.visual;
    this.tipo; // "input" "dropdown" "tacos"
    this.condicion;
    this.relacion;
    this.compuesto;
    this.GetAcabado = function (cod) {
      return this.acabados.filter((acabado) => acabado.cod == cod)[0];
    };
    this.GetAcabadosValidos = function (perfil) {
      var acabados = [];

      this.acabados.forEach((acabado) => {
        if (acabado.condicion == "") {
          acabados.push(acabado);
        } else {
          const resultado = eval(acabado.condicion); // Se evalua contra perfil
          if (resultado) {
            acabados.push(acabado);
          }
        }
      });
      return acabados;
    };
  }
}
